import React, { useEffect, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiCall } from '../utils/api';
import { useAuth } from '../utils/AuthContext';
import '../styles/styles.css';

const SuccessPage = () => {
    const { authState } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const safeAuthState = useMemo(() =>
        authState || { accessToken: null, userId: null, userEmail: '' },
        [authState]
    );
    const urlParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const sessionId = urlParams.get('session_id');

    useEffect(() => {
        console.log('[SuccessPage] authState:', safeAuthState);
        const handleStripeReturn = async () => {
            const redirectStatus = urlParams.get('redirect_status');

            if (redirectStatus === 'succeeded' && sessionId) {
                try {
                    console.log('[SuccessPage] Verifying session with sessionId:', sessionId, 'accessToken:', safeAuthState.accessToken);
                    await apiCall(`/payments/status/${sessionId}`, 'GET', null, true, null, safeAuthState.accessToken);
                    // Optionally refresh balance here if needed
                } catch (error) {
                    console.error('[SuccessPage] Error verifying session:', error);
                }
            }
            // Clear query params
            window.history.replaceState({}, document.title, location.pathname);
        };

        handleStripeReturn();
    }, [safeAuthState, sessionId, urlParams, location.pathname]);

    const handleBackToPayment = () => {
        console.log('[SuccessPage] Navigating to /upgrade, authState:', safeAuthState);
        navigate('/upgrade');
    };

    const handleBackToHome = () => {
        console.log('[SuccessPage] Navigating to home, authState:', safeAuthState);
        navigate('/');
    };

    return (
        <div className="main-content success-page">
            <h2>Payment Successful!</h2>
            <p>Your points have been added. Thank you for your purchase.</p>
            <div className="button-group">
                <button className="back-button" onClick={handleBackToPayment}>
                    Back to Payment
                </button>
                <button className="back-button" onClick={handleBackToHome}>
                    Back to Home
                </button>
            </div>
        </div>
    );
};

export default SuccessPage;